import { PREFERENCE_KEYS } from 'types';

export interface OrganizationChangeEvent {
  organization: string;
}
export const ORG_CHANGE_EVENT = 'currentOrganizationChanged';

export const sessionTenantManager = {
  setCurrentOrganization: (organization: string) => {
    const current = sessionTenantManager.getCurrentOrganization();
    localStorage.setItem(PREFERENCE_KEYS.DEFAULT_ORGANIZATION, organization);
    window.dispatchEvent(
      new CustomEvent<OrganizationChangeEvent>(ORG_CHANGE_EVENT, {
        detail: {
          organization,
        },
      })
    );
    if (current && organization !== current) {
      window.location.reload();
    }
  },
  getCurrentOrganization: () => {
    return localStorage.getItem(PREFERENCE_KEYS.DEFAULT_ORGANIZATION);
  },
  clearCurrentOrganization: () => {
    localStorage.removeItem(PREFERENCE_KEYS.DEFAULT_ORGANIZATION);
    window.dispatchEvent(
      new CustomEvent<OrganizationChangeEvent>(ORG_CHANGE_EVENT, {
        detail: {
          organization: '',
        },
      })
    );
  },
};
